<template>
  <tr>
    <td>
      <b-form-textarea
        :disabled="readOnly"
        v-model="objTest.medida"
      ></b-form-textarea>
    </td>
    <td>
      <b-form-textarea
        :disabled="readOnly"
        v-model="objTest.resultados"
      ></b-form-textarea>
    </td>
    <td>
      <i v-if="!readOnly" @click="removeItem(objTest)" class="bx bxs-trash"></i>
    </td>
  </tr>
</template>
<script>
export default {
  props: ["removeItem", "objTest", "readOnly"],
};
</script>
<style scoped>
.controller-forms {
  font-size: 0.8rem !important;
  width: 100% !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.bxs-trash {
  font-size: 1.5rem;
  color: #25a2b7;
  cursor: pointer;
}
</style>
